import React, {useState, useEffect, useContext} from 'react';
import styled from 'styled-components';
import OutputText from '@ey/canvascoreservices/OutputText';
import Step2OrgChart from './step2OrgChart';
import {ProjectContext} from './Helper/context';
import * as projectActionTypes from '../CreateProjectClassic/Helper/projectActionTypes';
import {labels, currentResource} from '../../../util/utils';
import * as ProjectActions from '../../../actions/Project/projectcreationactions';
import {createProjectStepsIndex} from '../../../util/uiconstants';
import * as errorActions from '../../../actions/erroractions';

const CreateProjectStep2 = (props) => {
	const {state, dispatch} = useContext(ProjectContext);
	const [isLoading, setIsLoading] = useState(false);
	const nodes = props.nodes;

	// Clear local storage for the position of step 3 and step 4 org chart
	useEffect(() => {
		localStorage.removeItem('StateStep2OrgChart');
		return () => {
			localStorage.removeItem('StateStep2OrgChart');
		};
	}, []);

	// Validates data when 'Continue' is clicked
	useEffect(() => {
		let hasValidData = isValidData();
		if (props.continueToNextStep && hasValidData) {
			// If valid data, first update reducer data and then Make API call for updates on server
			setIsLoading(true);
			dispatch({type: projectActionTypes.UPDATE_STEP2_DATA, payload: props.nodes});
			props.setActiveStepIndex(createProjectStepsIndex.connectToEYCanvas);
			props.setContinueToNextStep(false);
		} else {
			if (!hasValidData) {
				errorActions.raiseJSValidationError(currentResource.clientValidationErrors.ErrorStep2DataNotComplete);
			}
			props.setContinueToNextStep(false);
		}
	}, [props.continueToNextStep]);

	const isValidData = () => {
		if (
			props.nodes.length > 0 &&
			props.nodes.forEach((x) => x.entityName.trim() && x.entityName !== labels.enterEntityName)
		) {
			return true;
		}
		return false;
	};

	return (
		<StyledStep2Section className="step2">
			<div className="header-content">
				<OutputText h4>{labels.step2InstructionHeader}</OutputText>
				<OutputText light>{labels.step2SubInstructionPart1}</OutputText>
			</div>
			<StyledStep2OrgChartSection>
				<Step2OrgChart nodes={nodes} setNodes={props.setNodes} />
			</StyledStep2OrgChartSection>
		</StyledStep2Section>
	);
};
export default CreateProjectStep2;

const StyledStep2Section = styled.section`
	.header-content {
		display: flex;
		flex-direction: column;
	}
`;

const StyledStep2OrgChartSection = styled.section`
	.boc-chart-menu {
		min-width: 12rem;
		box-shadow: rgb(0 0 0 / 50%) 0 0.1rem 0.4rem 0 !important;
		background-color: ${(props) => props.theme.color[`white`]} !important;
		border-radius: 0;
		svg {
			display: none;
		}
		&::before {
			content: '';
			width: 1.6rem;
			height: 1.6rem;
		}

		[data-item] {
			padding: 0.5rem 1rem
			&:first-child {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			}
			&:last-child {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}

	.boc-toolbar-container {
		left: var(--px-18);
		top: var(--px-18);
		display: flex;
		flex-direction: column;
		width: 4rem;
	}

	.boc-edit-form {
		border: solid 1px ${(props) => props.theme.color[`grey300`]};
		border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};
		background-color: ${(props) => props.theme.color[`white`]} !important;
		border-radius: 0;
		right: 1px !important;
		height: 37% !important;
		position: fixed !important;
		top: 40% !important;
		right: 3% !important;
		opacity: 1 !important;

		.boc-edit-form-title {
			display: none;
		}

		.boc-edit-form-header {
			height: 5rem !important;
			border-radius: 0;
			background: ${(props) => props.theme.color[`white`]} !important;
			display: flex;
			justify-content: end;
		}

		.boc-edit-form-close {
			top: 1rem;
		}

		.boc-edit-form-avatar,
		.boc-edit-form-instruments {
			display: none;
		}

		.boc-form-fieldset {
			padding: 1rem !important;
			flex-direction: row-reverse;
			justify-content: flex-end;
		}
		.boc-edit-form-fields {
			position: relative;
			overflow: hidden;
			background-color: ${(props) => props.theme.color[`white`]};
		}

		.close-icon {
			text-align: right;
			font-size: 1.6rem;
			padding: 1rem 1rem 0 0;
			cursor: pointer;
			color: ${(props) => props.theme.color[`black`]};
			width: 2rem;
		}

		.boc-validation-error-message {
			position: absolute;
			top: 6rem;
			left: 0.5rem;
			color: ${(props) => props.theme.color[`red600`]};
		}

		.boc-edit-form-fields-inner {
			margin-bottom: 0;

			.boc-form-field {
				flex: 0 0 100%;
				padding: 0;
			}
			.boc-form-fieldset {
				padding: 0 !important;
				justify-content: unset;
				background-color: ${(props) => props.theme.color[`white`]};
			}

			.boc-input {
				> input {
					border: 0;
					border-bottom: solid 2px ${(props) => props.theme.color[`grey300`]};
					border-radius: 0;
					padding-left: 10px;
					background: transparent;
					color: ${(props) => props.theme.color[`grey400`]};
					font-family: 'EYInterstate' !important;
				}
				> label {
					font-size: 1.4rem;
					color: ${(props) => props.theme.color[`grey300`]};
					font-weight: 300;
					top: -0.1rem;
					padding-bottom: 6rem;
				}
			}
		}

		.boc-form-field {
			flex: 0 0 25%;
		}

		.boc-button {
			height: 3.6rem;
			padding-top: 0;
			border-radius: 0;
			&[data-edit-from-save] {
				background-color: ${(props) => props.theme.color[`grey500`]};
				border-color: ${(props) => props.theme.color[`grey500`]};
				color: ${(props) => props.theme.color[`white`]};
				&:hover {
					background-color: ${(props) => props.theme.color[`white`]};
					border-color: ${(props) => props.theme.color[`grey500`]};
					color: ${(props) => props.theme.color[`grey500`]};
				}
			}
			&[data-edit-from-cancel] {
				background-color: ${(props) => props.theme.color[`white`]};
				border-color: ${(props) => props.theme.color[`grey500`]};
				color: ${(props) => props.theme.color[`grey500`]};
				&:hover {
					background-color: ${(props) => props.theme.color[`grey500`]};
					border-color: ${(props) => props.theme.color[`grey500`]};
					color: ${(props) => props.theme.color[`white`]};
				}
			}
		}

		.boc-button {
			text-transform: capitalize;
		}
	}

	.boc-chart-menu > div[data-item] {
		border-bottom: 0 !important;
		cursor: pointer;
		background-color: ${(props) => props.theme.color[`white`]} !important;
		span {
			font-size: 1.2rem;
			color: ${(props) => props.theme.color[`grey500`]} !important;
		}
		&:hover {
			background-color: ${(props) => props.theme.color[`grey200`]} !important;
		}
	}
`;
